import { DownloadIcon } from "lucide-react";
import React from "react";
import styled from "styled-components";
import UIModal from "./UIModal/UIModal";
import useModal from "@src/hooks/useModal";
import DownloadDesktopApp from "@src/pages/DownloadDesktopApp/DownloadDesktopApp";
import Tooltip from "./Tooltip";

const Button = styled.a`
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background-color: ${({ theme }) => theme.colors.darkBg};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.main};
  border-radius: 12px;
  height: 40px;
  max-width: 200px;
  padding: 0 16px;
  font-size: 12px;
  text-align: center;
  text-decoration: none;
  transition:
    background-color 0.3s ease,
    transform 0.1s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: ${({ theme }) => theme.colors.black};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const DesktopDownloadButton: React.FC = () => {
  const isMac = window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
  const isWindows = window.navigator.platform.toUpperCase().indexOf("WIN") >= 0;

  const getDownloadUrl = () => {
    if (isMac) return process.env.REACT_APP_DOWNLOAD_APP_MAC_URL || "#";
    if (isWindows) return process.env.REACT_APP_DOWNLOAD_APP_WINDOWS_URL || "#";
    return "#";
  };

  const downloadUrl = getDownloadUrl();
  const { closeModal, isOpen, openModal } = useModal();

  const ButtonText = styled.span`
    @media (max-width: 1024px) {
      display: none;
    }
  `;

  return (
    <>
      <Tooltip position="bottom" content="Download Desktop App">
        <Button
          onClick={() => {
            if (!isMac && !isWindows) {
              openModal();
            }
          }}
          href={downloadUrl}
          target={isMac || isWindows ? "_blank" : "_self"}
        >
          <DownloadIcon size={14} />
          <ButtonText>Desktop App</ButtonText>
        </Button>
      </Tooltip>
      <UIModal
        headerStyles={{
          textAlign: "center",
        }}
        title="Download App"
        isOpen={isOpen}
        onClose={closeModal}
        actions={[]}
      >
        <DownloadDesktopApp
          goBackAction={closeModal}
          goBackText="Close"
          style={{ height: "50vh" }}
        />
      </UIModal>
    </>
  );
};

export default DesktopDownloadButton;
